const menu = {
  baseStyle: {
    list: {
      borderColor: "app-border",
      _dark: { "--menu-bg": "colors.app-card" },
      boxShadow: "md",
    },
    item: {
      _hover: { bg: "app-muted" },
      _focus: { bg: "app-muted" },
    },
  },
};

export default menu;
